import {
  signIn,
  confirmSignIn,
  fetchAuthSession,
  resetPassword,
  confirmResetPassword
} from '@aws-amplify/auth';
import {Amplify} from 'aws-amplify';
import axios from 'axios';

const AESO_METERED_VOLUME_API_KEY =
  process.env.REACT_APP_AESO_METERED_VOLUME_API_KEY || 'e8c0563b0d924de48f959bea711184b7';

//  Configures the Authentication to the local region and data group
Amplify.configure({
  region: 'ca-central-1',
  userPoolId: 'ca-central-1_20c8GxbbK',
  userPoolWebClientId: '18b35cuujo69224s4ctelffo75'
})

const parseAllowedPlants = (raw) => {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw.map((plant) => String(plant)).filter(Boolean);
  }
  if (typeof raw !== "string") {
    raw = String(raw);
  }
  const trimmed = raw.trim();
  if (!trimmed) return [];
  if (trimmed.startsWith("[")) {
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.map((plant) => String(plant)).filter(Boolean);
      }
    } catch (error) {
      console.error("Failed to parse allowedPlants JSON:", error);
    }
  }
  return trimmed
    .split(/[;,|]+/)
    .map((plant) => plant.trim())
    .filter(Boolean);
};

const normalizeCustomerId = (value) => {
  if (value == null) return "";
  if (typeof value !== "string") {
    value = String(value);
  }
  return value.trim();
};

const resolveCustomerId = (explicitCustomerId, idToken) => {
  const explicit = normalizeCustomerId(explicitCustomerId);
  if (explicit) return explicit;
  const fromToken = normalizeCustomerId(idToken?.payload?.["custom:customerID"]);
  if (fromToken) return fromToken;
  return "WCEC";
};

//  initializes the Apis
class AppApi {
  //  This function is for requesting data form our Apis Data tables
  async queryDataApi (queryString) { //  This takes a query and searchs it in the Api
    const user = await fetchAuthSession()
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      redirect: 'follow'
    }
    return axios.get('https://rveytb2q86.execute-api.ca-central-1.amazonaws.com/dev/api' + queryString, requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
  async getUserRole() {
  try {
    const session = await fetchAuthSession();

    const idToken = session.tokens?.idToken;
    if (!idToken) {
      console.log("No ID token found");
      return null;
    }

    // Cognito attributes are stored inside token payload
    const role = idToken.payload["custom:customerRole"];
    return role;

  } catch (err) {
    console.error("Failed to fetch user role:", err);
    return null;
  }
}
  async getUserPowerplants() {
  try {
    const session = await fetchAuthSession();

    const idToken = session.tokens?.idToken;
    if (!idToken) {
      console.log("No ID token found");
      return [];
    }

    // Cognito attributes are stored inside token payload
    const rawPlants = idToken.payload["custom:allowedPlants"];
    return Array.from(new Set(parseAllowedPlants(rawPlants)));

  } catch (err) {
    console.error("Failed to fetch user powerplants:", err);
    return [];
  }
}
  async queryAILApi () { //  This takes a query and searchs it in the Api
    // const user = await Auth.currentAuthenticatedUser()
    // const token = user.tokens.idToken.toString();
    const user = await fetchAuthSession()
    
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      redirect: 'follow'
    }
    console.log('6')
    return axios.get('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/getail', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
    async queryInstantaneousRestatement (options = {}) { //  This takes a query and searchs it in the Api
    // const user = await Auth.currentAuthenticatedUser()
    // const token = user.tokens.idToken.toString();
    const user = await fetchAuthSession();
    const idToken = user.tokens?.idToken;
    const token = idToken ? idToken.toString() : "";

    const resolvedOptions = typeof options === "string" ? { plant: options } : options;
    const {
      plant,
      customerID,
      param = "instantaneousRestatement",
      value = 1
    } = resolvedOptions || {};

    const allowedPlants = parseAllowedPlants(idToken?.payload?.["custom:allowedPlants"]);
    const fallbackPlant = allowedPlants[0] || "wlc1";
    const resolvedPlant = plant || fallbackPlant;
    const resolvedCustomerId = resolveCustomerId(customerID, idToken);

    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      data: {
        plant: resolvedPlant,
        customerID: resolvedCustomerId,
        param,
        value,
        parameterName: param,
        parameterValue: value
      }
    }
    console.log('6')
    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/instantaneous-restatement', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
  async queryMonthlyGenApi () { //  This takes a query and searchs it in the Api
    // const user = await Auth.currentAuthenticatedUser()
    // const token = user.tokens.idToken.toString();
    const user = await fetchAuthSession()
    
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      redirect: 'follow'
    }
    return axios.get('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/CurrentMonthGenerationRevenue ', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
  async queryTNGApi(assetIdentifier) {
    // Assuming fetchAuthSession() is a function that retrieves the current user's session
    const user = await fetchAuthSession();
    ;
    const token = user.tokens.idToken.toString();
   
    // Define the request body with the asset identifier
    const requestBody = {
       assetIdentifier: assetIdentifier
    };
   
    // Define the request options including headers and method
    const requestOptions = {
       method: 'POST',
       headers: {
         Authorization: 'Bearer ' + token,
         'Content-Type': 'application/json' // Specify the content type as JSON
       },
       data: requestBody // Include the request body
    };
   
    // Make the POST request using axios
   return axios.post('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/grabCSDTNG', requestBody, requestOptions)
        .then(res => res.data)
       .catch(error => console.log('error', error));
   }
  async queryAesoMeteredVolumeDetailsApi(startDate, endDate, assetId) {
    if (!startDate || !endDate || !assetId) {
      return null;
    }
    const requestOptions = {
      headers: {
        'Cache-Control': 'no-cache',
        'API-KEY': AESO_METERED_VOLUME_API_KEY,
      },
      params: {
        startDate,
        endDate,
        asset_ID: assetId,
      },
    };

    return axios
      .get('https://apimgw.aeso.ca/public/meteredvolume-api/v1/meteredvolume/details', requestOptions)
      .then((res) => res.data)
      .catch((error) => {
        console.log('queryAesoMeteredVolumeDetailsApi error', error);
        throw error;
      });
  }
  async queryAlarmApi () { //  This takes a query and searchs it in the Api
    // const user = await Auth.currentAuthenticatedUser()
    // const token = user.tokens.idToken.toString();
    const user = await fetchAuthSession()
    const token = user.tokens.idToken.toString();
    console.log('token ',token)
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      redirect: 'follow'
    }
    return axios.get('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/getAlarms', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
  async queryCSDApi () { //  This takes a query and searchs it in the Api
    // const user = await Auth.currentAuthenticatedUser()
    // const token = user.tokens.idToken.toString();
    const user = await fetchAuthSession()
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      redirect: 'follow'
    }
    return axios.get('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/grabCSD', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
  async queryHCFApi () { //  This takes a query and searchs it in the Api
    // const user = await Auth.currentAuthenticatedUser()
    // const token = user.tokens.idToken.toString();
    const user = await fetchAuthSession()
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      redirect: 'follow'
    }
    return axios.get('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/getHCF', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
  async queryRockbashApi (hours_back,hours_forward) { //  This takes a query and searchs it in the Api
    // const user = await Auth.currentAuthenticatedUser()
    // const token = user.tokens.idToken.toString();
    const user = await fetchAuthSession();
    const token = user.tokens.idToken.toString();
   
    const data = {
       "hours_back": hours_back,
       "hours_forward": hours_forward,
    };
   
    const requestOptions = {
       method: 'POST',
       headers: {
         Authorization: 'Bearer ' + token,
         'Content-Type': 'application/json'
       },
       data: data
    };
    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/rockbash', requestOptions)
       .then(res => res.data)
       .catch(error => console.log('error', error));
   }
  // 'GeneratorAvailabilityParam'

  async updateParameterStoreApi(parameterName, newValue, plant, customerID) {
    const user = await fetchAuthSession();
    const idToken = user.tokens?.idToken;
    const token = idToken ? idToken.toString() : "";

    const allowedPlants = parseAllowedPlants(idToken?.payload?.["custom:allowedPlants"]);
    const fallbackPlant = allowedPlants[0] || "wlc1";
    const resolvedPlant = plant || fallbackPlant;
    const resolvedCustomerId = resolveCustomerId(customerID, idToken);
    const payloadValue = typeof newValue === "string" ? newValue : JSON.stringify(newValue);

    const requestOptions = {
       method: 'POST',
       headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
       data: {
         param: parameterName,
         value: payloadValue,
         parameterName: parameterName,
         parameterValue: payloadValue,
         plant: resolvedPlant,
         customerID: resolvedCustomerId
       }
    };
   
    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/SetSchedulerBotConfig', requestOptions)
       .then(res => res.data)
       .catch(error => console.log('error', error));
   }
async grabRevenue(assetIdentifier, plant, hoursBack) {
  const user = await fetchAuthSession();
  const idToken = user.tokens?.idToken;
  const token = idToken ? idToken.toString() : "";

  // Basic required check (match your style)
  if (assetIdentifier && idToken) {

    const data = {
      asset_identifier: assetIdentifier
    };

    // Optional inputs (same behavior you already had)
    if (plant !== undefined && plant !== null && String(plant).trim()) {
      data.plant = String(plant).trim();
    }

    if (hoursBack !== undefined && hoursBack !== null) {
      data.hours_back = hoursBack;
    }

    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      data: data
    };

    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/RevenueGrab', requestOptions)
      .then(res => res.data)
      .catch(error => {
        console.log('grabRevenue error', error);
        throw error;
      });
  }
}

  async querySchedulerBotApi (param, plant, customerID) { //  This takes a query and searchs it in the Api

    const user = await fetchAuthSession();
    const idToken = user.tokens?.idToken;
    const token = idToken ? idToken.toString() : "";

    const resolvedCustomerId = resolveCustomerId(customerID, idToken);
    if (plant && param && idToken){
      const data = {
       "param": param,
       "plant": plant,
       "customerID": resolvedCustomerId
    };
      const requestOptions = {
       method: 'POST',
       headers: {
         Authorization: 'Bearer ' + token,
         'Content-Type': 'application/json'
       },
       data: data
    };
   
    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/schedulerbotConfig', requestOptions)
       .then(res => {
         const data = res.data;
         if (data && typeof data === "object" && Object.prototype.hasOwnProperty.call(data, "value")) {
           return data.value;
         }
         return data;
       })
       .catch(error => console.log('error', error));
    }
    
   
    
  }
   
   async checkCoil(ip, coil_address) {
    // Assuming you have a function to fetch the authentication token
    const user = await fetchAuthSession();
    const token = user.tokens.idToken.toString();
   
    const data = {
       "ip": ip,
       "coil_address": coil_address
    };
   
    const requestOptions = {
       method: 'POST',
       headers: {
         Authorization: 'Bearer ' + token,
         'Content-Type': 'application/json'
       },
       data: data
    };
   
    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/checkCoil', requestOptions)
       .then(res => res.data)
       .catch(error => console.log('error', error));
   }
   
  async queryOperationsApi (asset) { //  This takes a query and searchs it in the Api
    // const user = await Auth.currentAuthenticatedUser()
    // const token = user.tokens.idToken.toString();
    const user = await fetchAuthSession()
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      data: {
        asset: asset
      }
    }
    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/grabOperationsData', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
    async queryRockbashAccuracyApi () { 
    const user = await fetchAuthSession()
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      redirect: 'follow'
    }
    return axios.get('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/getRockbashAccuracy', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
  async queryGetBidDataApi (plant) { 
    const user = await fetchAuthSession()
    const idToken = user.tokens?.idToken;
    const token = idToken ? idToken.toString() : "";

    const allowedPlants = parseAllowedPlants(idToken?.payload?.["custom:allowedPlants"]);
    const fallbackPlant = allowedPlants[0] || "wlc1";
    const resolvedPlant = plant || fallbackPlant;
    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      data: {
        plant: resolvedPlant
      }
    }
    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/getBidData', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
    async queryRockbashAccuracyTimeSeriesApi () { 
    const user = await fetchAuthSession()
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      redirect: 'follow'
    }
    return axios.get('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/getRockbashAccuracyTimeSeries', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
  async queryPPandRB () { 
    const user = await fetchAuthSession()
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      redirect: 'follow'
    }
    return axios.get('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/getPPandRB', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
    async queryShortTermPPandRB () { 
    const user = await fetchAuthSession()
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      redirect: 'follow'
    }
    return axios.get('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/shortTermForecastandPP', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }
  async rebootAS() { 
    const user = await fetchAuthSession()
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      redirect: 'follow'
    }
    return axios.get('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/rebootAS', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error))
  }

  async getRunningRebootTargets() {
    console.log('[getRunningRebootTargets] start');
    try {
      const user = await fetchAuthSession();
      const token = user?.tokens?.idToken?.toString?.() || '';
      console.log('[getRunningRebootTargets] token present:', Boolean(token));

      const requestOptions = {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      };

      console.log(
        '[getRunningRebootTargets] request:',
        'https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/get_as_sf_running'
      );

      return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/get_as_sf_running', requestOptions)
        .then(res => {
          console.log('[getRunningRebootTargets] response:', res?.data);
          return res.data;
        })
        .catch(error => {
          console.log('[getRunningRebootTargets] axios error:', error);
          throw error;
        });
    } catch (error) {
      console.log('[getRunningRebootTargets] pre-request error:', error);
      throw error;
    }
  }

  async getPowerplantTotalOutput(plant) {
    const user = await fetchAuthSession();
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      data: { plant }
    };
    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/getPowerplantTotalOutput', requestOptions)
      .then(res => res.data)
      .catch(error => console.log('error', error));
  }

  async rebootInstance(instanceId, name) {
    const user = await fetchAuthSession();
    const token = user.tokens.idToken.toString();
    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      data: {
        instance_id: instanceId,
        name
      }
    };
    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/rebootAS', requestOptions)
      .then(res => res.data)
      .catch(error => {
        console.log('error', error);
        throw error;
      });
  }

  //  initializes the axiosinstance for development mode and production mode
  axiosInstance = axios.create({
    baseURL: `${//  If it is in development mode axios uses a proxy to bypass cors errors
      process.env.NODE_ENV === 'development'
      ? 'https://cors-anywhere.herokuapp.com/'
      : ''
      }https://api.aeso.ca/report`, //  If not in development mode axios does not use a proxy
    timeout: 5000,
    headers: {
      'X-API-Key': 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ0am1pZXoiLCJpYXQiOjE2OTEwODUzODd9.a5dnheEXl7UmFahBiemw8bEpsy3pgBJ23rkhFEljMCk',
      Accept: 'application/json'
    }
  })
  
  //  This function is for requesting data form Aeso's Apis Data tables
  async fetchDataAeso (endpoint, retryCount = 3) {
    return await this.axiosInstance.get(endpoint).then(res => res.data).catch(error =>
      error.code === 'ECONNABORTED' && retryCount > 0
        ? (console.log('Timeout exceeded, retrying...'), this.fetchDataAeso(endpoint, retryCount - 1))
        : console.error('error', error))
  }

  //  This function signs the user in
  signIn (username, password) {
    return signIn({username, password})
  }
  //  This function confirm signs the user in
  ConfirmSignIn (username, password) {
    return confirmSignIn({challengeResponse: password})
  }
  async forgotPassword(username) {
    return resetPassword({ username });
  }

  async confirmForgotPassword(username, code, newPassword) {
    return confirmResetPassword({
      username,
      confirmationCode: code,
      newPassword
    });
  }

  async getSession() {
    return fetchAuthSession();
  }

  async queryHourlyRevenue(assetIds) {
    const user = await fetchAuthSession();
    const idToken = user.tokens?.idToken;
    const token = idToken ? idToken.toString() : "";
    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      data: { asset_ids: assetIds }
    };
    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/get_revenue_hourly', requestOptions)
      .then(res => res.data)
      .catch(error => {
        console.log('queryHourlyRevenue error', error);
        throw error;
      });
  }

  async queryAthenaRevenue(assetIds) {
    const user = await fetchAuthSession();
    const idToken = user.tokens?.idToken;
    const token = idToken ? idToken.toString() : "";
    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      data: { asset_ids: assetIds }
    };
    return axios('https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/get_revenue_monthly', requestOptions)
      .then(res => res.data)
      .catch(error => {
        console.log('queryAthenaRevenue error', error);
        throw error;
      });
  }

  async getCurrentSupplyDemand(assetIdentifier, monthsBack = 2) {
    const user = await fetchAuthSession();
    const idToken = user.tokens?.idToken;
    const token = idToken ? idToken.toString() : "";
    const requestOptions = {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
      data: { plant: assetIdentifier, months_back: monthsBack }
    };
    return axios(
      'https://ue4byompwb.execute-api.ca-central-1.amazonaws.com/Dev/getCurrentSupplyDemand',
      requestOptions
    ).then(res => res.data).catch(error => { console.log('getCurrentSupplyDemand error', error); throw error; });
  }
}

export default AppApi
